import { auth } from ".";
import Parse from "./parse.service";

const OnboardingClass = Parse.Object.extend("Onboarding");
const Kyc = Parse.Object.extend("Kyc");

export const getKycIdByUserId = async () => {
    const user = await auth.fetchUser();
    const query = new Parse.Query(OnboardingClass);
    query.equalTo("userId", user);
    query.select("kycId");
    const onboarding = await query.first();
    return onboarding?.get("kycId")?.id;
}

export const getUserBasic = async () => {
    const kycId = await getKycIdByUserId();
    if (!kycId) return;
    const query = new Parse.Query(Kyc);
    query.select("basic");
    const kyc = await query.get(kycId);
    return kyc?.get("basic");
}

//method to update user details
export const updateUserBasic = async (data) => {
    const kycId = await getKycIdByUserId();
    if (!kycId) return;
    const query = new Parse.Query(Kyc);
    const kyc = await query.get(kycId);

    kyc.set("basic", {
        ...kyc?.get("basic"),
        ...data
    });

    const res = await kyc.save();
    return res?.get("basic")
}